<template>
  <section class="content-current">
    <div class="row">
      <div class="col-md-11"></div>
      <div class="col-md-1">
        <router-link to="/profile/dashboard">
          <div title="بازگشت به داشبورد" class="close"></div>
        </router-link>
      </div>
    </div>
    <div class="content-current">
      <div class="row">
        <div class="col-md-4 group_mdi col-xs-12">
          <input v-model="voucherNumber" type="number" />
          <span class="highlight"></span>
          <span class="bar"></span>
          <label class="lbl-report"> شماره واچر</label>
        </div>
        <div class="col-md-4 group_mdi col-xs-12">
          <input v-model="reserveNumber" type="number" />
          <span class="highlight"></span>
          <span class="bar"></span>
          <label class="lbl-report"> شماره رزرو</label>
        </div>
        <div class="col-md-4 col-xs-12" style="
            margin-top: 28px;
            float: left;
            text-align: center;
            margin-bottom: 1rem;
          ">
          <button type="submit" v-if="!showLoadingbar" class="btn btn-primary" @click.prevent="search()">
            جستجو
          </button>
          <button v-else type="submit" class="btn btn-primary"
            style="background-color: #ccdbd2; height: 45px; font-size: 14px">
            جستجو
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="col-md-12 loading" v-if="showLoadingbar" style="text-align: center">
      <loadingBar type="ripple" />
    </div>
    <div v-if="showSearchDetail">
      <div v-if="!showLoadingbar">
        <div class="card-header">
          <h4>
            ویرایش اطلاعات
            <span style="color: #08446a; font-weight: 600">{{ title }}</span>
          </h4>
        </div>
        <div class="row content-current">
          <div class="col-md-12 col-xs-12">
            <div class="box box-info">
              <div class="box-header">
                <h3 class="box-title">
                  <i class="fa fa-info-circle fa-fw" style="color: #178a00"></i><label>اطلاعات رزرو</label>
                </h3>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-md-4 col-sm-4">
                    <label> تاریخ صدور: </label>
                    {{ data.createdDate | persianDate("jYYYY/jMM/jDD") }}
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <label>تعداد مهمان: </label>
                    {{ data.adult }} بزرگسال- {{ data.child }} کودک-
                    {{ data.infant }} نوزاد
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <label> نحوه پرداخت: </label> {{ data.paymentTypeTitle }}
                  </div>
                </div>
                <div>
                  <template v-if="data.addOnOptions.length">
                    <hr />
                    <div class="box-header">
                      <h3 class="box-title">
                        <i class="icon-dot-3" style="color: #e04f67"></i><label>سایر خدمات </label>
                      </h3>
                    </div>
                  </template>
                  <template v-for="addon in data.addOnOptions" v-if="data.addOnOptions.length">
                    <div class="row" v-if="addon.selectedCount > 0">
                      <div class="col-md-4 col-sm-4">
                        <label> نام: </label>
                        {{ addon.name }}
                      </div>

                      <div class="col-md-4 col-sm-4">
                        <label>تعداد: </label>
                        {{ addon.selectedCount }}
                      </div>
                    </div>
                  </template>
                  <hr />
                  <div class="row">
                    <div class="col-md-4 col-sm-4">
                      <label> </label>
                    </div>

                    <div class="col-md-4 col-sm-4">
                      <label> </label>
                    </div>
                    <div class="col-md-4 col-sm-4">
                      <label> قیمت کل : </label>
                   
                      {{ data.paiedAmount | numFormat }}
                      ريال
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box box-success content-current">
          <div class="box-header">
            <h3 class="box-title">
              <i class="fa fa-user fa-fw" style="color: #d5ab3d"></i><label>اطلاعات مشتری</label>
            </h3>
          </div>

          <div class="row">
            <div class="col-md-4 col-xs-12">
              <div class="group_mdi">
                <input type="text" v-model="data.customerFirstName" @blur="$v.data.customerFirstName.$touch()"
                  :class="{ invalid: $v.data.customerFirstName.$error }" />
                <label><span class="validation-color">*</span> نام</label>
                <span class="highlight"></span>
                <span class="bar"></span>
                <p class="text-danger" v-if="
                  !$v.data.customerFirstName.required &&
                  $v.data.customerFirstName.$dirty
                ">
                  لطفا نام را وارد کنید
                </p>
              </div>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="group_mdi">
                <input class="col-xs-12" v-model="data.customerLastName" type="text"
                  @blur="$v.data.customerLastName.$touch()" :class="{ invalid: $v.data.customerLastName.$error }" />
                <label><span class="validation-color">*</span> نام خانوادگی</label>
                <span class="highlight"></span>
                <span class="bar"></span>
                <p class="text-danger" v-if="
                  !$v.data.customerLastName.required &&
                  $v.data.customerLastName.$dirty
                ">
                  لطفا نام خانوادگی را وارد کنید
                </p>
              </div>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="group_mdi">
                <input v-model="data.customerMobileNumber" @blur="$v.data.customerMobileNumber.$touch()" :class="{
                  invalid:
                    mobileValidation.errors.length &&
                    $v.data.customerMobileNumber.$dirty,
                }" maxlength="11" />
                <label><span class="validation-color">*</span>شماره همراه</label>
                <span class="highlight"></span>
                <span class="bar"></span>
                <p class="text-danger" v-if="
                  mobileValidation.errors.length &&
                  $v.data.customerMobileNumber.$dirty
                ">
                  شماره وارد شده معتبر نمی باشد
                </p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-xs-12">
              <div class="group_mdi">
                <input v-model="data.customerNationalId" type="text" maxlength="10" />
                <label>
                  <span class="validation-color"> </span>شماره پاسپورت</label>
                <span class="highlight"></span>
                <span class="bar"></span>
              </div>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="group_mdi">
                <input type="text" v-model="data.customerEmail" @blur="$v.data.customerEmail.$touch()"
                  :class="{ invalid: $v.data.customerEmail.$error }" />
                <label><span class="validation-color"> </span>پست الکترونیک</label>
                <span class="highlight"></span>
                <span class="bar"></span>
                <p class="text-danger" v-if="!$v.data.customerEmail.email">
                  پست الکترونیک وارد شده معتبر نمیباشد
                </p>
              </div>
            </div>
            <div class="col-md-4 col-xs-12">
              <div>
                <label>تغییر تاریخ ورود به </label>

                <date-picker id="editDate" readonly :min="minToDate" locale="en" format="YYYY/MM/DD"
                  display-format="YYYY/MM/DD" v-model="data.arrivalDate" :column="1" mode="single" auto-submit
                  @blur="$v.data.arrivalDate.$touch()" :class="{ invalid: $v.data.arrivalDate$error }">
                </date-picker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-xs-12">
              <div class="group_mdi">
                <input type="text" maxlength="10" v-model="data.extensionData" @blur="$v.data.extensionData.$touch()"
                  :class="{ invalid: $v.data.extensionData.$error }" />
                <label><span class="validation-color">*</span> شماره پرواز</label>
                <span class="highlight"></span>
                <span class="bar"></span>
                <p class="text-danger" v-if="
                  !$v.data.extensionData.required &&
                  $v.data.extensionData.$dirty
                ">
                  لطفا شماره پرواز را وارد کنید
                </p>
              </div>
            </div>
            <div class="col-md-8 col-xs-12">
              <div class="group_mdi">
                <textarea placeholder="توضیحات " class="style-textarea" type="text" rows="2"
                  v-model="data.customerRequest" />
                <label><span class="validation-color"> </span></label>
                <span class="highlight"></span>
                <span class="bar"></span>
              </div>
            </div>
          </div>
        </div>
        <template v-if="data.bookingGuests.length > 1">
          <div class="box box-success content-current">
            <div class="box-header">
              <h3 class="box-title">
                <i class="icon-flight filter-icon" style="color: #2a69b1"></i><label> همراهان</label>
              </h3>
            </div>

            <div v-for="(guest, i) in data.bookingGuests.filter(
              (p) => p.isCustomerReserver === false
            )" :set="(v = $v.data.bookingGuests.$each[i])" class="row">
              <div class="col-md-4 col-xs-12">
                <div class="group_mdi">
                  <input type="text" v-model="guest.firstName" @blur="v.firstName.$touch()"
                    :class="{ invalid: v.firstName.$error }" />
                  <label class="special-labels"><span class="validation-color">*</span>
                    <span v-if="guest.ageCategoryId === 3"> نام بزرگسال </span>
                    <span v-if="guest.ageCategoryId === 2"> نام کودک </span>
                    <span v-if="guest.ageCategoryId === 1"> نام نوزاد </span>
                  </label>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <p class="text-danger" v-if="!v.firstName.required && v.firstName.$dirty">
                    لطفا نام را وارد کنید
                  </p>
                </div>
              </div>
              <div class="col-md-4 col-xs-12">
                <div class="group_mdi">
                  <input class="col-xs-12" type="text" v-model="guest.lastName"
                    :class="{ invalid: v.lastName.$error }" />
                  <label class="special-labels"><span class="validation-color">*</span>
                    <span v-if="guest.ageCategoryId === 3">
                      نام خانوادگی بزرگسال
                    </span>
                    <span v-if="guest.ageCategoryId === 2">
                      نام خانوادگی کودک
                    </span>
                    <span v-if="guest.ageCategoryId === 1">
                      نام خانوادگی نوزاد
                    </span>
                  </label>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <p class="text-danger" v-if="!v.lastName.required && v.lastName.$dirty">
                    لطفا نام خانوادگی بزرگسال را وارد کنید
                  </p>
                </div>
              </div>
              <div class="col-md-4 col-xs-12">
                <div class="group_mdi">
                  <input class="col-xs-12" type="text" v-model="guest.nationalCode"
                    :class="{ invalid: v.nationalCode.$error }" maxlength="10" />
                  <label class="special-labels"><span class="validation-color">*</span>
                    <span v-if="guest.ageCategoryId === 3">پاسپورت بزرگسال
                    </span>
                    <span v-if="guest.ageCategoryId === 2"> پاسپورت کودک </span>
                    <span v-if="guest.ageCategoryId === 1">
                      پاسپورت نوزاد
                    </span>
                  </label>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <p class="text-danger" v-if="!v.nationalCode.required && v.nationalCode.$dirty">
                    لطفا شماره پاسپورت بزرگسال {{ i + 2 }} را وارد کنید
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div class="row"></div>
        <div class="row">
          <div class="col-md-12 col-xs-12">
            <div>
              <label><span class="validation-color"> </span>توضیحات ویرایش</label>
              <textarea class="styled-textarea" type="text" rows="2" v-model="data.description" />
            </div>
          </div>
        </div>
        <hr />
        <div class="col-md-12" style="text-align: center" v-if="!showLoadingbar">
          <button class="btn btn-primary btn-search" type="button" aria-expanded="false" @click="editInfo"
            :disabled="$v.$invalid" :class="{ disabledBtn: $v.$invalid }">
            ویرایش اطلاعات
          </button>
        </div>
        <div class="col-md-12" style="text-align: center" v-else>
          <button class="btn btn-primary btn-search" type="button" aria-expanded="false" disabled="disabled">
            ویرایش اطلاعات
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  required,
  email,
  maxLength,
  minLength,
  requiredIf,
} from "vuelidate/lib/validators";
import store from "../../../views/tourism/store/index";
import loadingBar from "../../../components/loading/pdkLoadingBar";
import moment from "moment-jalaali";
import PdkDatePicker from "@/components/PdkDatePicker";

var qs = require("qs");

export default {
  store,
  components: { loadingBar, PdkDatePicker },

  data() {
    return {
      isAdmin: false,
      voucherNumber: "",
      reserveNumber: "",
      showSearchDetail: false,
      showLoadingbar: false,
      providerId: 2,
      arrivalDate: "",
      minToDate: new Date(),
      now: moment,
      data: {
        customerRequest: "",
        customerFirstName: "",
        customerLastName: "",
        customerMobileNumber: "",
        customerEmail: "",
        isCustomerReserver: true,
        birthDate: "",
        nationalCode: "",
        extensionData: "",
      },
      title: "فست ترک امام خمینی",
      rules: [
        { message: "شماره وارد شده معتبر نمی باشد.", regex: /(09)[0-9]{9}/ },
      ],
    };
  },
  validations() {
    return {
      data: {
        bookingGuests: {
          $each: {
            firstName: { required },
            lastName: { required },
            nationalCode: { required, maxLength: maxLength(10) },
          },
        },
        customerFirstName: { required },
        customerLastName: { required },
        extensionData: {
          required: requiredIf(function (model) {
            const isValid = this.providerId == 2 ? true : false;
            return isValid;
          }),
        },

        customerMobileNumber: {
          required,
          maxLength: maxLength(11),
          minLength: minLength(11),
        },
        customerEmail: { email, maxLength: maxLength(100) },
        arrivalDate: { required },
      },
    };
  },
  computed: {
    mobileValidation() {
      let errors = [];
      for (let condition of this.rules) {
        if (!condition.regex.test(this.data.customerMobileNumber)) {
          errors.push(condition.message);
        }
      }
      if (errors.length === 0) {
        return { valid: true, errors };
      } else {
        return { valid: false, errors };
      }
    },
  },
  created() { },
  methods: {
    async search() {
      this.showLoadingbar = true;
      //check shekeri userid
      if (
        localStorage.getItem("UserId") ===
        "E03BD1E5-449B-4F99-B3D6-1658E2B6B3CA"
      ) {
        this.isAdmin = true;
      }

      const data = {
        voucherNumber: this.voucherNumber,
        reserveNumber: this.reserveNumber,
        sourceProfileId: localStorage.getItem("SourceProfileId"),
        isAdmin: this.isAdmin,
      };
      const res = await this.$store.dispatch("getBookingItemForEdit", data);
      if (res.data != undefined) {
        if (res.data.length) {
          this.data = Object.assign(res.data[0]);

          this.minToDate = moment(new Date()).format("YYYY/MM/DD");
          this.arrivalDate = moment(this.data.arrivalDate).format("YYYY/MM/DD");

          this.showLoadingbar = false;
          this.showSearchDetail = true;
        } else {
          this.showLoadingbar = false;
          this.showSearchDetail = false;

          // alert("ویرایش این رزرو امکان پذیر نیست.");
          this.$toast.error("ویرایش این رزرو امکان پذیر نیست.", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
        }
      } else {
        this.showLoadingbar = false;
        this.showSearchDetail = false;
      }
    },
    async editInfo() {
      this.showLoadingbar = true;
      this.data.departureDate = this.arrivalDate;
      this.data.isAdmin = this.isAdmin;

      this.data.bookingGuests = this.data.bookingGuests.filter(
        (p) => p.isCustomerReserver === false
      );

      const result = await this.$store.dispatch("editFastTrackInfo", this.data);

      alert(result.data[0].message);
      this.$toast.success(result.data[0].message, {
        position: "top-center",
        timeout: 4500,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 1.59,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        icon: true,
        rtl: true,
      });
      this.showLoadingbar = false;
      this.showSearchDetail = false;
    },
  },
};
</script>

<style scoped>
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

caption {
  font-size: 28px;
  margin-bottom: 15px;
}

th {
  background-color: #f0f0f0;
}

h4,
p {
  margin: 0px;
}
</style>
<style >
#editDate .vpd-input-group {
  display: table;
  width: 100%;
  position: relative;
  border: 1px solid #dadada;

}

#editDate .vpd-input-group input {
  border-right: none !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-radius: 0px !important;
  /* line-height: 30px; */
  padding: 0 10px;
  height: 37px !important;
  border-top: 0px !important;
  border-bottom: 0px !important;
  font-weight: 100;
}

#editDate .vpd-input-group label {
  background-color: #417df4 !important;

}

</style>
